import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyInformationPopoverIcon({
  IconComponent
}) {
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "-100" // centers the icon vertically in the row
    ,
    children: /*#__PURE__*/_jsx(IconComponent, {
      color: "icon-core-subtle" // sets the color to match icons in EditorFieldOption, etc.
      ,
      size: "500" // sets the size to match icons in EditorFieldOption, etc.
    })
  });
}